import styled, { css } from 'styled-components';
/* stylelint-disable declaration-block-no-duplicate-properties */
export const Grid = styled.div<GridProps>`
  /* Basic fallback for IE11 */

  display: flex;
  flex-wrap: wrap;
  display: grid;
  grid-template-columns: ${props =>
    props.columnTemplate ||
    `repeat(${props.columnCount || 'auto-fill'}, minmax(${
      props.columnMinWidth || 'auto'
    }, ${props.columnMaxWidth || '1fr'}))`};
  grid-gap: ${props => props.gap || '10px'};

  > * {
    /* grid-gap fallback for IE11 */
    ${props =>
      props.gap &&
      css`
        margin-bottom: ${props.gap};
        margin-right: ${props.gap};
      `}

    @supports (display: grid) {
      margin-bottom: 0;
      margin-right: 0;
    }
  }
`;
/* stylelint-enable declaration-block-no-duplicate-properties */
interface GridProps {
  children?: React.ReactNode | undefined;
  columnTemplate?: string;
  columnCount?: number | string;
  columnMinWidth?: number | string;
  columnMaxWidth?: number | string;
  gap?: string;
}
